import { render, staticRenderFns } from "./winCourseDeYu.vue?vue&type=template&id=00965954&scoped=true"
import script from "./winCourseDeYu.vue?vue&type=script&lang=js"
export * from "./winCourseDeYu.vue?vue&type=script&lang=js"
import style0 from "./winCourseDeYu.vue?vue&type=style&index=0&id=00965954&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00965954",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('00965954')) {
      api.createRecord('00965954', component.options)
    } else {
      api.reload('00965954', component.options)
    }
    module.hot.accept("./winCourseDeYu.vue?vue&type=template&id=00965954&scoped=true", function () {
      api.rerender('00965954', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/winCourseDeYu.vue"
export default component.exports